import React from 'react';
import { Bell, BellOff, Pencil, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Card, CardContent } from '../ui/card';
import { useOptionsLocale } from '../../context/OptionsLanguageContext';

export const OptionsAlertRuleCard = ({ rule, onEdit, onToggle, onDelete, busy = false }) => {
  const { t } = useOptionsLocale();

  return (
    <Card className="border-white/10 bg-white/[0.03] text-white shadow-none" data-testid={`options-alert-rule-card-${rule.id}`}>
      <CardContent className="space-y-4 p-4">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="space-y-2">
            <div className="flex flex-wrap items-center gap-2">
              <p className="text-sm font-semibold uppercase tracking-[0.18em] text-white/45" data-testid={`options-alert-rule-card-scope-${rule.id}`}>{rule.scope_label}</p>
              <Badge variant="outline" className="border-white/10 bg-white/[0.03] text-white/70" data-testid={`options-alert-rule-card-type-${rule.id}`}>
                {t(`optionsAlerts.types.${rule.alert_type}.label`)}
              </Badge>
              <Badge className={`${rule.enabled ? 'bg-emerald-500/15 text-emerald-200' : 'bg-white/8 text-white/60'}`} data-testid={`options-alert-rule-card-state-${rule.id}`}>
                {rule.enabled ? t('optionsAlerts.active') : t('optionsAlerts.paused')}
              </Badge>
            </div>
            <h3 className="text-lg font-semibold text-white" data-testid={`options-alert-rule-card-condition-${rule.id}`}>{rule.condition_summary}</h3>
            <div className="flex flex-wrap items-center gap-3 text-sm text-white/58">
              <span data-testid={`options-alert-rule-card-channels-${rule.id}`}>
                {rule.channels?.in_app ? 'GENI' : null}
                {rule.channels?.in_app && rule.channels?.email ? ' + ' : null}
                {rule.channels?.email ? 'Email' : null}
              </span>
              {rule.operation_expiration_label ? <span data-testid={`options-alert-rule-card-expiration-${rule.id}`}>{t('optionsAlerts.nextExpiry')}: {rule.operation_expiration_label}</span> : null}
              {rule.last_triggered_at ? <span data-testid={`options-alert-rule-card-last-trigger-${rule.id}`}>{t('optionsAlerts.lastTriggered')}</span> : null}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <Button type="button" size="icon" variant="ghost" className="text-white/70 hover:bg-white/10 hover:text-white" onClick={() => onToggle(rule)} disabled={busy} data-testid={`options-alert-rule-card-toggle-${rule.id}`}>
              {rule.enabled ? <BellOff size={16} /> : <Bell size={16} />}
            </Button>
            <Button type="button" size="icon" variant="ghost" className="text-white/70 hover:bg-white/10 hover:text-white" onClick={() => onEdit(rule)} disabled={busy} data-testid={`options-alert-rule-card-edit-${rule.id}`}>
              <Pencil size={16} />
            </Button>
            <Button type="button" size="icon" variant="ghost" className="text-red-300/80 hover:bg-red-500/10 hover:text-red-200" onClick={() => onDelete(rule)} disabled={busy} data-testid={`options-alert-rule-card-delete-${rule.id}`}>
              <Trash2 size={16} />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default OptionsAlertRuleCard;